


















import {Vue, Component, Watch, Prop} from 'vue-property-decorator';
import * as echartsImport from '../../../static/lib/echarts.min.js';
let echarts: any = echartsImport;

@Component
export default class App extends Vue {
    @Prop({
        type: Array,
    })
    callCount?: Array<number>;

    @Watch('callCount')
    onCallCountChanged(newCallCount) {
        this.draw(newCallCount);
    }

    draw (newCallCount) {
        let subDay = d => new Date(d.getTime()-1000*60*60*24);

        let d = new Date;
        d = subDay(d);
        let dArr = [];
        for (let i = 0; i < 7; i++) {
            let t = d.getMonth()+1 + '/' + d.getDate();
            dArr.push(t);
            d = subDay(d);
        }

        let myChart = echarts.init(this.$refs.chartWrap);
        let option = {
            tooltip : {
                show: true,
                trigger: 'axis',
                axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                    type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                }
            },
            grid: {
                top: '10%',
                left: 0,
                right: 0,
                bottom: '10%',
                containLabel: true,
                show: false,
            },
            xAxis : [
                {
                    type : 'category',
                    show: true,
                    // data : ['1周', '2周', '3周', '4周', '5周', '6周', '7周'],
                    data : dArr.reverse(),
                    axisTick: {
                        alignWithLabel: true
                    },
                    axisLine:{
                        lineStyle:{
                            color: 'transparent',
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#7584CD',
                            fontSize: '10'
                        },
                    },
                }
            ],
            yAxis : [{show: false}],
            series : [
                {
                    type: 'bar',
                    name: 'SPO三元组数量',
                    barWidth: '10px',
                    data: newCallCount,
                    // [10, 52, 200, 334, 390, 330, 220],
                    itemStyle: {
                        borderColor: '#323061',
                        color: {
                            type: 'linear',
                            x: 0, y: 0, x2: 0, y2: 1,
                            // colorStops: [{offset: 0, color: '#FFEBAC'}, {offset: 1, color: '#FFAA4E'}],
                            colorStops: [{offset: 0, color: '#137E91'}, {offset: 1, color: '#44D1F7'}],
                            shadowColor: 'rgba(0,0,0,0.50)',
                            shadowBlur: 7,
                            shadowOffsetX: 0,
                            shadowOffsetY: -2,
                            globalCoord: false
                        },
                    }
                },
            ]
        };
        myChart.setOption(option, true);
    }

    mounted () {

    }
}
